module.exports = __webpack_public_path__ + "static/4-624d3db4df78f9a6587db63f3b2e72ef.jpg";